import { render, staticRenderFns } from "./MemoTxnForm.vue?vue&type=template&id=36c21d6f&scoped=true"
import script from "./MemoTxnForm.vue?vue&type=script&lang=js"
export * from "./MemoTxnForm.vue?vue&type=script&lang=js"
import style0 from "./MemoTxnForm.vue?vue&type=style&index=0&id=36c21d6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c21d6f",
  null
  
)

export default component.exports